module.exports = __webpack_public_path__ + "img/pdf40.51b64645.png";